import { createApp } from 'vue'
import App from './App.vue'
import './assets/index.css'
import helper from "@/utils/helper";
import store from './store'
import router from './router'
import Toast from "vue-toastification";
import PerfectScrollbar from "vue3-perfect-scrollbar";
import "vue3-perfect-scrollbar/dist/vue3-perfect-scrollbar.css";
// Import the CSS or use your own!
import "vue-toastification/dist/index.css";
import * as ConfirmDialog from 'vuejs-confirm-dialog'
import {Tabs, Tab} from 'vue3-tabs-component';
import VueProgressBar from "@aacassandra/vue3-progressbar";
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

const options = {
    color: "#bffaf3",
    failedColor: "#874b4b",
    thickness: "5px",
    transition: {
      speed: "0.2s",
      opacity: "0.6s",
      termination: 300,
    },
    autoRevert: true,
    location: "top",
    inverse: false,
  };
const app = createApp(App)
.use(router)
.use(store)
.use(helper)
.use(Toast)
.use(PerfectScrollbar)
.use(ConfirmDialog)
.use(VueSweetalert2)
.use(VueProgressBar, options)
.component('tabs', Tabs)
.component('tab', Tab)

.mount('#app');
export default app